export const getStartOfWeek=dateLocale=>{const weekStartsOn=dateLocale.options?.weekStartsOn??0;return 0===weekStartsOn?7:weekStartsOn};